'use client';
import styled from 'styled-components';
import { BodyTextRegularC } from '@/shared/ui/typography2';

interface CheckboxProps {
  checked: boolean;
  onClickHandler: () => void;
  label?: string;
  id?: string;
}

export const PwCheckbox = ({
  checked,
  onClickHandler,
  label,
  id,
}: CheckboxProps) => {
  return (
    <StyledCheckbox
      id={id}
      checked={checked}
      onClick={() => {
        onClickHandler();
      }}
    >
      <IconWrapper>
        <CheckIcon $checked={checked}>
          <CheckIndicator />
        </CheckIcon>
      </IconWrapper>
      {label && <BodyTextRegularC color={'#AFAFAF'}>{label}</BodyTextRegularC>}
    </StyledCheckbox>
  );
};

const CheckIcon = styled.div`
  display: flex;
  width: 46px;
  height: 24px;
  padding: 2px;
  justify-content: flex-start;
  align-items: center;
  gap: 2px;

  border-radius: 20px;
  background: #625a63;

  ${({ $checked }) =>
    $checked &&
    `
      justify-content: flex-end;
      background: #ff9500;
    `}
`;

const CheckIndicator = styled.div`
  width: 20px;
  height: 20px;
  flex-shrink: 0;

  border-radius: 20px;
  background: #fff;
`;

const StyledCheckbox = styled.button`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  justify-items: flex-start;
  align-items: center;
  gap: 12px;
  cursor: pointer;
`;
const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
